/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { SnackbarProvider } from 'notistack';
import { CustomSwitch, CustomTable } from '../../../../components';
import useStyle from './useStyle';
import useGetProviderById from '../../../../services/providers/useGetProviderById';

const ProvidersPaymentTable = ({ providers }) => {
  const classes = useStyle();
  // const [selectedProvider, setSelectedProvider] = useState(null);
  const [providersRows, setProvidersRows] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentProvider = providers?.[currentIndex];
  const { data: providerData } = useGetProviderById(currentProvider?.beneficiaryId, currentProvider?.type);

  useEffect(() => {
    if (providerData) {
      const newRow = {
        id: currentProvider.beneficiaryId,
        name: currentProvider.reference,
        category: providerData?.creditorAgent,
        pay_method: providerData?.supplementaryData?.[0]?.paymentMethod,
        payment: providerData?.supplementaryData?.[0]?.instructedAmount?.hasPartialPayment ? 'Si' : 'No',
        actions: createActions(),
        state: createStatusSwitch(providerData),
        active: 1,
      };

      setProvidersRows((prev) => [...prev, newRow]);
      setCurrentIndex((prev) => prev + 1);
    }
  }, [providerData]);

  useEffect(() => {
    setProvidersRows([]);
    setCurrentIndex(0);
  }, [providers]);

  function createActions() {
    return (
      <Box display="flex" flexDirection="row" justifyContent="center">
        <IconButton
          edge="end"
          aria-label="Editar"
          size="small"
          classes={{ disabled: classes.disabled }}
          disabled
        >
          <Tooltip title="Editar" aria-label="edit" placement="top">
            <EditIcon className={classes.editIcon} />
          </Tooltip>
        </IconButton>
        <IconButton
          edge="end"
          aria-label="Delete"
          size="small"
          disabled
          style={{ paddingLeft: 10 }}
          classes={{ disabled: classes.disabled }}
        >
          <Tooltip title="Eliminar" aria-label="delete" placement="top">
            <DeleteIcon className={classes.editIcon} />
          </Tooltip>
        </IconButton>
      </Box>
    );
  }

  function createStatusSwitch(providerParam) {
    return (
      <Tooltip title="Cambiar estado" aria-label="changeState" placement="top">
        <Box alignSelf="center">
          <CustomSwitch
            checked={providerParam.status}
            name="active"
            disabled
          />
        </Box>
      </Tooltip>
    );
  }

  const columns = [
    { id: 'id', label: 'ID', paddingLeft: '40px', width: 150, position: 1 },
    { id: 'name', label: 'Nombre', paddingLeft: '40px', width: 150, position: 2 },
    { id: 'category', label: 'Categoría', paddingLeft: '40px', width: 150, position: 3 },
    { id: 'pay_method', label: 'Método de pago', paddingLeft: '40px', width: 10, position: 4 },
    { id: 'payment', label: 'Abono', paddingLeft: '40px', width: 10, position: 6 },
    { id: 'actions', paddingLeft: '', label: 'Acciones', width: 5, position: 7 },
    { id: 'state', paddingLeft: '', label: 'Estado', width: 5, position: 7 },
  ];

  return (
    <SnackbarProvider>
      <CustomTable
        data={providersRows}
        columns={columns}
        readOnly
      />
    </SnackbarProvider>
  );
};

export default ProvidersPaymentTable;